export class AirbridgeHelper {
  checkAvailability() {
    return !!window.airbridge.isSDKEnabled
  }

  redirect({ url, isOpenNewWindow = false }: { url: string; isOpenNewWindow?: boolean }) {
    const optionFunction = isOpenNewWindow
      ? // eslint-disable-next-line @typescript-eslint/no-explicit-any
        function (_err: any, res: any) {
          window.open(res.targetUrl)
        }
      : undefined

    window.airbridge.sendWeb(url, optionFunction)
  }
}
